import { FC } from "react";
import Image from "next/image";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { useTranslations } from "next-intl";

export type BlockType = {
  title: string;
  image?: string;
  icon?: string;
  headerDescription?: string;
  description: string;
}

interface ISocialBlock {
  block: BlockType
}

const Block: FC<ISocialBlock> = ({ block }) => {
  const t = useTranslations();

  return (
    <div className={S.borderContainer}>
      <Container className={S.wrapper}>
        <div className={S.mainInfo}>
          <h3 className={S.title}>{t(block.title)}</h3>
          {block.image && <Image className={S.image} src={block.image} alt={block.title} width={450} height={260} />}
          {block.icon && <Image className={S.icon} src={block.icon} alt={block.title} width={300} height={300} />}
        </div>
        <div className={S.descriptionWrap}>
          {block.headerDescription && <p className={S.headerDescription}>{t(block.headerDescription)}</p>}
          <div className={S.description} dangerouslySetInnerHTML={{ __html: t.raw(block.description) }} />
        </div>
      </Container>
    </div>
  );
};

export default Block;